// useNodeTypeSchemaCacheRefresh.js

import { useCallback } from 'react';

// Firebase
import { db } from 'firebaseConfig';

// Services
import { syncNodeTypeSchemaCacheForBase } from 'services/nodetypes/NodeTypesCacheService';

/**
 * useNodeTypeSchemaCacheRefresh
 *
 * Returns a stable helper that refreshes node type schema cache for a base and type key.
 *
 * @returns {function} Cache refresh callback.
 */
export default function useNodeTypeSchemaCacheRefresh() {
  return useCallback(({ baseKey, typeKey, fields } = {}) => {
    const normalizedBaseKey = typeof baseKey === 'string' && baseKey.trim()
      ? baseKey.trim()
      : null;

    return syncNodeTypeSchemaCacheForBase(db, {
      baseKey: normalizedBaseKey,
      typeKey: typeof typeKey === 'string' ? typeKey.trim() : '',
      fields: Array.isArray(fields) ? fields : null,
      subscribe: false,
      ttlMs: 0,
    })
      .catch((error) => {
        console.warn('Node types cache refresh failed:', error);
      });
  }, []);
}
